module.exports = __webpack_public_path__ + "img/logo_eats.5f2fd96a.png";